// extracted by mini-css-extract-plugin
export default {"sociallinks":"SocialLinks_sociallinks__Yd1Kg","sociallinks__item":"SocialLinks_sociallinks__item__7iims"};